import React from "react";
import { Accordion, AccordionTab } from "primereact/accordion";
import SuburbReportPackCard from "./SuburbReportPackCard";
import { suburbReportPacks } from "./suburbReportsData";
import styles from "./SuburbReports.module.scss";

const SuburbReports: React.FC = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-cyan-50/50 via-white to-gray-50 py-4 px-2 sm:px-4 md:py-8 md:px-6 lg:px-10">
      <div className="w-full bg-white">
        {/* Modern Header Section matching Depreciation/InvestmentCalculators style */}
        <section className="overflow-hidden bg-white relative w-full">
          <div className="h-1.5 bg-gradient-to-r from-cyan-400 via-[var(--primary-color)] to-cyan-400" />

          <div className="px-4 py-4 md:px-10 md:py-6 bg-gradient-to-b from-white to-slate-50 relative z-10">
            <div className="max-w-4xl mx-auto flex flex-col items-center text-center">
              <span className="inline-flex items-center rounded-full border border-cyan-200 bg-cyan-50 text-[var(--primary-color)] text-[11px] md:text-xs font-bold uppercase tracking-wider px-3 py-1 shadow-sm  mb-3">
                Market Insights
              </span>
              <h1 className="text-3xl sm:text-4xl md:text-6xl font-bold text-black mb-2 mt-4 md:mb-3 md:mt-3 tracking-wide">
                Suburb Performance Reports
              </h1>

              <p className="text-slate-600 text-base sm:text-lg md:text-xl leading-relaxed max-w-3xl mx-auto">
                Download your Suburb Performance Reports each month to stay ahead of the latest suburb and property
                market trends. This powerful, exclusive data gives you the insights you need to pinpoint areas that
                align perfectly with your investment goals.
              </p>
            </div>
          </div>
        </section>
      </div>

      <section className=" bg-gray-100 p-4 md:p-8 w-full">
        <div className="flex flex-col mb-1 border-b border-slate-100 pb-1 text-center">
          <h1 className="font-semibold text-black mb-0 md:mb-2 tracking-wide mt-2 pb-0">Monthly Research Packs</h1>
          <h3 className="text-black text-sm md:text-base pt-0">
                Select a region below to download the latest performance data.
              </h3>
          </div>

          <Accordion activeIndex={0} className={styles.reportsAccordion}>
            {suburbReportPacks.map((pack) => (
              <AccordionTab
                key={pack.id}
                header={
                  <div className="flex items-center justify-between w-full pr-4">
                    <span className="text-sm sm:text-base md:text-lg font-bold tracking-tight">{pack.title}</span>
                  </div>
                }
                contentClassName="p-0"
              >
                <div className="pt-4 pb-2">
                  <SuburbReportPackCard pack={pack} />
                </div>
              </AccordionTab>
            ))}
          </Accordion>
        </section>
      </div>
  );
};

export default SuburbReports;
